/**
 * Created by User on 08/09/2016.
 */
export default AdURLModificator;

function AdURLModificator(refferer, player) {
  var _dl;
  var _refferer = refferer;
  var _player = player;
  var _this = this;

  this.modifyURL = function (url, position, cacheBoost) {
    if (!url) {
      return;
    }

    if (url.indexOf('v.adfox.ru') !== -1 || url.indexOf('/226279/') !== -1) {
      url = checkPuidsImho(url, position, cacheBoost);
    }

    if (url.indexOf('ads.adfox.ru') != -1 || url.indexOf('adv.gpm-digital.com') != -1) {
      url = checkPuids(url);
    }

    if (url.indexOf('ad.mail.ru') != -1) {
      url = checkPuidsRB(url);
    }

    if (url.indexOf('bs-meta.yandex.ru') != -1) {
      url = _this.replaceEventURL(url).url;
    }

    if (url.indexOf('kb.mgg') !== -1) {
      url = replaceByDeviceInfo(url);
    }
    return url;
  };

  this.replaceEventURL = function (url) {
    if (!url) {
      return;
    }

    var afReferrer;
    try {
      afReferrer = getAfReferrer();
    } catch (error) {}

    url = url.replace('![rnd]', getRandom());
    url = url.replace('[TIMESTAMP]', new Date().getTime());
    url = url.replace('[RANDOM]', getRandom());
    url = url.replace('[CACHEBUSTING]', getRandom());
    if (_refferer) {
      url = url.replace('[REFERER]', _refferer);
    }
    if (_refferer || afReferrer) {
      url = url.replace('[REFERERER]', afReferrer != 'undefined' ? afReferrer : _refferer);
    }

    url = url.replace('{random}', getRandom());
    if (_refferer) {
      url = url.replace('{referer}', _refferer);
    }
    if (_refferer || afReferrer) {
      url = url.replace('{rereferer}', afReferrer != 'undefined' ? afReferrer : _refferer);
    }

    if ((url.indexOf('ads.adfox.ru') != -1 || url.indexOf('adv.gpm-digital.com') != -1)) {
      var eventDL = getParameterByName('dl', url);

      if (eventDL == '' && _dl && _dl != '') {
        url = url + '&dl=' + _dl;
      }
    }

    return replaceByDeviceInfo(url);
  };

  function checkPuidsImho(url, position, cacheBoost) {

    var wdpm = _player.config.weboramaDPM || {};
    var socio = wdpm.socio_demographics || {};
    var clusters = (wdpm.clusters || []).slice(0, 10);
    var audiences = (wdpm.audiences || []).slice(0, 10);

    var puid6 = position;
    var puid30 = findPuid(url, /puid30=[0-9]{0,5}/);
    var puid33 = socio.gender || "0";
    var puid34 = socio.age || "0";
    var puid35 = socio.social_class || "0";
    var puid36 = '';
    var puid37 = '';

    while (clusters.length) puid36 += clusters.shift().toString() + (clusters.length ? ':' : '');
    while (audiences.length) puid37 += audiences.shift().toString() + (audiences.length ? ':' : '');

    var random = Math.floor(new Date().getTime() / 1000);
    var pr = cacheBoost;
    var page_url = _player.config.referer ? _player.config.referer.substr(0, 256) : null;
    var eid1 = puid30 + ':' + Math.floor(Math.random() * 2147483647) + ":" + pr;

    url = url.replace('[puid6]', puid6);
    url = url.replace('[puid33]', puid33);
    url = url.replace('[puid34]', puid34);
    url = url.replace('[puid35]', puid35);
    url = url.replace('[puid36]', puid36);
    url = url.replace('[puid37]', puid37);

    url = url.replace('[pr]', pr);
    url = url.replace('[random]', random);
    url = url.replace('[eid1]', eid1);

    if (page_url) {
      //trim http://, https://, //
    	page_url = page_url.indexOf('//') >= 0 ? page_url.substr(page_url.indexOf('//') + 2) : page_url;

      if (_player.get('deepTrackInfo') &&
        _player.get('deepTrackInfo').split('|').length > 1 &&
				_player.get('videoInfo').watermark &&
				_player.get('videoInfo').watermark.indexOf('megogo__water') === -1)
      {
        var deepTrack = _player.get('deepTrackInfo');
        var topDomain = deepTrack.indexOf('|') > 0 ? deepTrack.substr(deepTrack.lastIndexOf('|') + 1) : deepTrack;
        if (topDomain.indexOf('->') !== -1) topDomain = topDomain.substr(0, topDomain.indexOf('->'));
        url += ':' + topDomain + '?source=' + page_url;
      } else {
        url += ':' + _player.config.protocol + '//' + page_url;
      }
    }

    if (_player.get('ad:needAdfoxIpdid')) {
      var lpdid = _player.config.lpdid || "";
      url = url.replace('&dl', "&extid_tag=adfox&extid=" + lpdid + '&dl');
    }

    return url;
  }

  function findPuid(url, regexp) {
    var math = url.match(regexp);
    if (!math || !math.length) return null;

    var split = math[0].split('=');
    if (!split.length) return null;

    return split[1];
  }

  function checkPuids(url) {

    if (!isFullScreen()) {
      url += '&puid39=1';
      url += '&puid10=1';
    } else {
      url += '&puid39=0';
      url += '&puid10=0';
    }

    if (getParameterByName('dl', url)) {
      _dl = getParameterByName('dl', url);
    }


    /*pt - Флаг URI содержит время на стороне пользователя
		 По умолчанию рекомендуется передавать:pt=b
		 т.к. только в этом случае у Adfox будет возможность обрабатывать время пользователя.
		 pd - Число, только день месяца пользователя. (от 1 до 31)
		 pw - Число, только недели пользователя ( 1 – понедельник, 2 – вторник, 3 – среда, 4 – четверг, 5 – пятница, 6 – суббота, 7 – воскресенье)
		 pv - Число, только час пользователя (от 0 до 24)*/

    var date = new Date();
    url += '&pt=b';
    url += '&pd=' + date.getDate();
    url += '&pw=' + date.getDay();
    url += '&pv=' + date.getHours();

    var puid42 = getParameterByName('puid42');
    if (puid42 == '') {
      var regExp = /&puid42=/g;
      if (url.search(regExp) != -1) {
        url = url.replace(/&puid42=/g, '');
      }
    }

    var videoWidth, videoHeight;
    var playerContainer = document.getElementById('playerContainer');

    if (playerContainer) {
      if (playerContainer.offsetWidth / playerContainer.offsetHeight > 16 / 9) {
        videoHeight = playerContainer.offsetHeight;
        videoWidth = videoHeight * (16 / 9);
      } else {
        videoWidth = playerContainer.offsetWidth;
        videoHeight = videoWidth / (16 / 9);
      }
    }
    var playerResolution = 4;

    /*puid9– Размер плеера (5 -Менее 400х225, 0 - от 400х225 до 639х359, 1- от 640х360 до 959х539, 2 - от 960х540 до 1279х719, 3 - 1280х720 и более, 4 - не известно,)*/
    if (videoWidth < 400 && videoHeight < 225) {
      playerResolution = 5;
    } else if ((videoWidth >= 400 && videoHeight >= 225) && (videoWidth < 639 && videoHeight < 359)) {
      playerResolution = 0;
    } else if ((videoWidth >= 640 && videoHeight >= 360) && (videoWidth < 959 && videoHeight < 539)) {
      playerResolution = 1;
    } else if ((videoWidth >= 960 && videoHeight >= 540) && (videoWidth < 1279 && videoHeight < 719)) {
      playerResolution = 2;
    } else if (videoWidth >= 1280 && videoHeight >= 720) {
      playerResolution = 3;
    }

    if (puid42 == "") {
      url += '&puid42=' + playerResolution;
    }

    var puid9 = getParameterByName('puid9', url);
    if (puid9 == '') {
      url += '&puid9=' + playerResolution;
    }

    var eid2 = getParameterByName('eid2', url);
    var vclicksID = 'flash';
    var check;

    try {
      check = readVClicks();
    } catch (error) {}

    if (check) {
      vclicksID = check;
      if (url.indexOf('eid2') != -1) {
        url = url.replace('eid2=' + eid2, 'eid2=vc' + vclicksID);
      } else {
        url += '&eid2=vc' + vclicksID;
      }
    }

    return url;
  }

  function checkPuidsRB(url) {
    if (getParameterByName('dl', url)) {
      _dl = getParameterByName('dl', url);
    }

    var videoWidth, videoHeight;
    var playerContainer = document.getElementById('playerContainer');

    if (playerContainer) {
      if (playerContainer.offsetWidth / playerContainer.offsetHeight > 16 / 9) {
        videoHeight = playerContainer.offsetHeight;
        videoWidth = videoHeight * (16 / 9);
      } else {
        videoWidth = playerContainer.offsetWidth;
        videoHeight = videoWidth / (16 / 9);
      }
    }
    var playerResolution = 4;

    /*puid9– Размер плеера (5 -Менее 400х225, 0 - от 400х225 до 639х359, 1- от 640х360 до 959х539, 2 - от 960х540 до 1279х719, 3 - 1280х720 и более, 4 - не известно,)*/
    if (videoWidth < 400 && videoHeight < 225) {
      playerResolution = 5;
    } else if ((videoWidth >= 400 && videoHeight >= 225) && (videoWidth < 639 && videoHeight < 359)) {
      playerResolution = 0;
    } else if ((videoWidth >= 640 && videoHeight >= 360) && (videoWidth < 959 && videoHeight < 539)) {
      playerResolution = 1;
    } else if ((videoWidth >= 960 && videoHeight >= 540) && (videoWidth < 1279 && videoHeight < 719)) {
      playerResolution = 2;
    } else if (videoWidth >= 1280 && videoHeight >= 720) {
      playerResolution = 3;
    }

    if (url.indexOf('puid10') != -1) {
      if (getParameterByName('puid10', url) == '') {
        url = url.replace(/puid10=/, 'puid10=' + playerResolution);
      }
    } else {
      url += '&puid10=' + playerResolution;
    }

    var puid11 = isFullScreen() ? 0 : 1;
    if (url.indexOf('puid11') != -1) {
      if (getParameterByName('puid11', url) == "") {
        url = url.replace(/puid11=/, 'puid11=' + puid11);
      }
    } else {
      url += '&puid11=' + puid11;
    }

    var eid2 = getParameterByName('eid2', url);
    var vclicksID = 'flash';

    var check;
    try {
      check = readVClicks();
    } catch (error) {}

    if (check) {
      vclicksID = check;
      if (url.indexOf('eid2') != -1) {
        url = url.replace('eid2=' + eid2, 'eid2=vc' + vclicksID);
      } else {
        url += '&eid2=vc' + vclicksID;
      }
    }

    return url;
  }

  function replaceByDeviceInfo(url) {

		var match = {
			'[kb.mgg.apikey]': _player.config.api_key || "",
			'[kb.mgg.appversion]': _player.config.version || "",
			'[kb.mgg.vendor]': _player.config.deviceOS || "",
			'[kb.mgg.model]': _player.config.deviceModel || "",
			'[kb.mgg.diagonal]': _player.config.deviceDiagonal || "",
			'[kb.mgg.year]': _player.config.deviceYear || "",
			'[kb.mgg.user_id]': _player.config.userID || "",
			'[kb.mgg.device_id]': _player.config.deviceID || "",
			'[kb.mgg.screen_width]': _player.config.screenWidth || "",
			'[kb.mgg.screen_height]': _player.config.screenHeight || "",
			'[kb.mgg.user_agent]': window.encodeURIComponent(navigator.userAgent || ""),
			'[kb.mgg.app_name]': _player.config.appName || "",
			'[kb.mgg.app_bundle]': _player.config.appBundle || "",
			'[kb.mgg.app_store_url]': _player.config.appStoreUrl || "",
			'[kb.mgg.gdpr]': _player.config.gdpr ? "1" : "0",
			'[kb.mgg.gdpr_consent]': _player.config.gdprConsent || "",
			'[kb.mgg.nonce]': _player.config.palNonce || "",
			'[RANDOM]': getRandom(),
			'[CACHEBUSTING]': getRandom(),
		};

		var keys = Object.keys(match);
		for (var i = 0; i < keys.length; i++) {
			url = replaceStringByEncodingOrNot(url, keys[i], match[keys[i]]);
		}

    return url;
  }

	function replaceStringByEncodingOrNot(url, target, value) {
		var encodedTarget = encodeURIComponent(target);
		return url.replace(target, value).replace(new RegExp(encodedTarget, "gm"), value);
	}

  function getParameterByName(name, url) {
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec(url);
    if ( results == null )
      return "";
    else
      return results[1];
  }

  function isFullScreen() {
    return document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
  }

  function getRandom() {
    var rnd = Math.random();
    rnd = Math.floor(rnd * 100000000000);
    rnd = rnd < 0 ? -rnd : rnd;
    return rnd;
  }
}

AdURLModificator._instance = null;
AdURLModificator.initialize = function(refferer, player) {
  AdURLModificator._instance = new AdURLModificator(refferer, player);
};
AdURLModificator.getInstance = function() {
  if (AdURLModificator._instance) {
    return AdURLModificator._instance;
  }
  throw new Error('AdURLModificator not initialized. Call AdURLModificator.initialize(refferer)');
};
